import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import '@atlaskit/css-reset';
import App from './App';

ReactDOM.render(
  // localStorage.clear(),
  <App />,
  document.getElementById('root')
);


